/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import AltErrorWrapper from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/AltErrorWrapper/AltErrorWrapper';
import FormAlertBox from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormAlertBox/FormAlertBox';
import FormErrorHandler from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import React, { useCallback, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

const FormState = {
  InputEmail: 0,
  InputPassword: 1,
  InputMfa: 2,
};
const CHECK_EMAIL_API_URL = '/gateway/check-email';
const CHECK_PW_API_URL = '/gateway/submit';
const VERIFY_OTP_URL = '/gateway/verify-otp';
const API_CONFIG = {
  headers: {
    'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
  },
};

function LoginBox({
  setIsLogin,
  isExistingUser,
  existingEmail,
  isMfaRequired,
}) {
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [formErrors, setFormErrors] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formState, setFormState] = useState(isExistingUser
    ? FormState.InputPassword
    : FormState.InputEmail);
  const [mfaRequired, setMfaRequired] = useState(isMfaRequired);
  const [otp, setOtp] = useState('');
  const [remember, setRemember] = useState(false);

  const passwordButtonText = () => {
    let buttonText = (formState === FormState.InputPassword && !mfaRequired) ? 'Log In' : 'Next';
    if (isSubmitting && formState === FormState.InputPassword) {
      buttonText = 'Authenticating...';
    }
    return buttonText;
  };

  const handleSubmitEmail = () => {
    setIsSubmitting(true);
    setFormErrors([]);
    const formData = new FormData();
    formData.append('emailAddress', emailAddress);
    if (!emailAddress) {
      setFormErrors([{ message: 'Invalid email address.' }]);
      setIsSubmitting(false);
      return;
    }
    axios.post(CHECK_EMAIL_API_URL, formData, API_CONFIG)
      .then((response) => {
        if (response.data.success) {
          const { samlConfigName } = response.data.data;
          setFormState(FormState.InputPassword);
          if (samlConfigName) {
            // saml login
            window.location = `${window.location.origin}/auth/saml/login/${response.data.data.samlConfigName}`;
          } else if (response.data.data.mfaRequired) {
            // mfa login
            setMfaRequired(true);
          }
        } else {
          setFormErrors([...response.data.data]);
        }
      })
      .catch((err) => {
        setFormErrors([{ field: 'generic', message: err.message }]);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleSubmitLogin = () => {
    setIsSubmitting(true);
    setFormErrors([]);
    const formData = new FormData();
    formData.append('password', password);
    formData.append('emailAddress', existingEmail || emailAddress);
    axios.post(CHECK_PW_API_URL, formData, API_CONFIG)
      .then((response) => {
        if (response.data.success) {
          if (response.data.data.mfaRequired) {
            setFormState(FormState.InputMfa);
          } else {
            // navigate to logged in view
            window.location.reload();
          }
        } else {
          setFormErrors([{ field: 'password', message: response.data.data[0].message }]);
        }
      })
      .catch((err) => {
        setFormErrors([{ field: 'generic', message: err.message }]);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleSubmitMfa = () => {
    setIsSubmitting(true);
    setFormErrors([]);
    const formData = new FormData();
    formData.append('otp', otp);
    /* istanbul ignore next */
    formData.append('remember', remember ? '1' : '0');
    axios.post(VERIFY_OTP_URL, formData, API_CONFIG)
      .then((response) => {
        if (response.data.success) {
          // navigate to logged in view
          window.location.reload();
        } else {
          setFormErrors([{ field: 'otp', message: response.data.data[0].message }]);
        }
      })
      .catch((err) => {
        setFormErrors([{ field: 'generic', message: err.message }]);
      })
      .finally(() => setIsSubmitting(false));
  };

  /* istanbul ignore next */
  const handleKeyDown = useCallback(() => {
    switch (formState) {
      case FormState.InputEmail:
        handleSubmitEmail();
        break;
      case FormState.InputPassword:
        handleSubmitLogin();
        break;
      case FormState.InputMfa:
        handleSubmitMfa();
        break;
      default:
        break;
    }
  }, [
    formState,
    isSubmitting,
    formErrors,
    emailAddress,
    password,
    otp,
    remember,
    mfaRequired,
  ]);
  /* istanbul ignore next */
  React.useEffect(() => {
    const listener = (event) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault();
        handleKeyDown();
      }
    };
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [handleKeyDown]);

  /* istanbul ignore next */
  return (
    <>
      <FormErrorHandler errorList={formErrors} fieldList={['emailAddress', 'password', 'otp']}>
        <form>
          <FormAlertBox />
          <ul className="list-unstyled ">
            <li>
              <div className="row">
                <div className="col-xs-12 col-sm-7">
                  <div className="form-group mb-3">
                    <AltErrorWrapper fieldId="emailAddress">
                      <input
                        type="text"
                        name="emailAddress"
                        id="emailAddress"
                        className="form-control w-100"
                        placeholder="Email address"
                        aria-label="email"
                        disabled={formState !== FormState.InputEmail}
                        onChange={(e) => setEmailAddress(e.target.value)}
                        value={existingEmail || emailAddress}
                      />
                    </AltErrorWrapper>
                  </div>
                </div>
                <div className="col">
                  {
                        formState === FormState.InputEmail
                         && (
                         <button
                           type="button"
                           id="submit-email"
                           className="btn btn-primary"
                           onClick={handleSubmitEmail}
                           disabled={isSubmitting}
                         >
                           {isSubmitting ? 'Authenticating...' : 'Next'}
                         </button>
                         )
                }
                </div>
              </div>
            </li>
            {
                formState !== FormState.InputEmail && (
                <li>
                  <div className="row">
                    <div className="col-xs-12 col-sm-7">
                      <div className="form-group">
                        <AltErrorWrapper fieldId="password">
                          <input
                            id="password-input"
                            type="password"
                            className="form-control w-100"
                            placeholder="Password"
                            aria-label="password"
                            disabled={formState !== FormState.InputPassword}
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                          />
                        </AltErrorWrapper>
                      </div>
                    </div>
                    <div className="col">
                      {
                          formState === FormState.InputPassword
                           && (
                           <button
                             type="button"
                             id="submit-password"
                             className="btn btn-primary"
                             onClick={handleSubmitLogin}
                             disabled={isSubmitting}
                           >
                             {passwordButtonText()}
                           </button>
                           )
                }
                    </div>
                  </div>
                </li>
                )
             }
            {
                formState === FormState.InputMfa && (
                <li>
                  <div className="row">
                    <div className="col-xs-12 col-sm-7">
                      <div className="form-group">
                        <AltErrorWrapper fieldId="otp">
                          <input
                            id="otp-input"
                            type="text"
                            className="form-control w-100"
                            placeholder="one-time passcode"
                            aria-label="otp"
                            onChange={(e) => setOtp(e.target.value)}
                            value={otp}
                          />
                        </AltErrorWrapper>
                        <small className="text-muted sm-text-nowrap">
                          Enter your one-time passcode from your authenticator app.
                        </small>
                        <div className="form-check mt-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="rememberCheck"
                            checked={remember}
                            onChange={() => setRemember(!remember)}
                          />
                          <label className="form-check-label" htmlFor="RememberCheck">Remember this device for 30 days</label>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      {
                  formState === FormState.InputMfa
                  && (
                    <button
                      type="button"
                      id="otp-submit"
                      className="btn btn-primary"
                      onClick={handleSubmitMfa}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Authenticating...' : 'Verify'}
                    </button>
                  )
                }
                    </div>
                  </div>
                </li>
                )
             }
            <li>
              {
                  formState === FormState.InputEmail
                    && (
                      <span className="text-fs-1 text-nowrap">
                        {' '}
                        <button id="set-login" type="button" className="btn p-0" onClick={() => setIsLogin(false)}>
                          {' '}
                          <small className="text-muted font-italic">
                            New to Room Alert Account?
                            {' '}
                            <a href="#" onClick={(e) => e.preventDefault()}>Register.</a>
                          </small>
                        </button>
                      </span>
                    )
}
              {
                    formState === FormState.InputPassword && (
                      <a href="/gateway/request-password-reset" target="_blank">
                        <span className="text-fs-1 text-nowrap">
                          <button
                            type="button"
                            className="btn btn-link p-0"
                          >
                            <small>
                              Forgot Password?
                            </small>
                          </button>
                        </span>
                      </a>
                    )
                }
            </li>
          </ul>
        </form>
      </FormErrorHandler>
    </>
  );
}

LoginBox.defaultProps = {
  setIsLogin: () => {},
  isExistingUser: false,
  existingEmail: null,
  isMfaRequired: false,
};

LoginBox.propTypes = {
  setIsLogin: PropTypes.func,
  isExistingUser: PropTypes.bool,
  existingEmail: PropTypes.string || null,
  isMfaRequired: PropTypes.bool,
};

export default LoginBox;
